export default __webpack_public_path__ + "static/media/switcherIcon.1e9fea25.svg";